import { Component, OnInit, Input } from '@angular/core';
import { WorkItemModel } from '../../../models/work-item';
import { BehaviorSubject } from 'rxjs';
import { UIMenuModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-menu-material',
  templateUrl: './e5core-ui-work-menu-material.component.html',
  styleUrls: ['./e5core-ui-work-menu-material.component.css']
})
export class E5CoreUiWorkMenuMaterialComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItems: UIMenuModel[] ;

  constructor() { }

  ngOnInit() {
  }

}
